import {useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {fetchSettings} from "../../reducers/settings";

const TargetYear = ({children}) => {
    const placeholder = ':target_year:';
    const dispatch = useDispatch();
    const currentYear = useSelector(state => state.settings.currentYear);
    const currentMonth = useSelector(state => state.settings.currentMonth);
    const isLoaded = useSelector(state => state.settings.isLoaded);
    useEffect(() => {
        if (!isLoaded) {
            dispatch(fetchSettings())
        }
    }, [currentYear, isLoaded, dispatch]);
    let targetYear = currentMonth < 8 ? currentYear : currentYear + 1;
    if (!children) {
        return(<>{targetYear}</>);
    }
    if (!children.includes(placeholder)) {
        return (<>{children}</>);
    }
    return(<>{children.replace(placeholder, targetYear)}</>);
}

export default TargetYear;